export default "__VITE_ASSET__04533016__"